import VueKonva from 'vue-konva';

export default VueKonva;
